import RestaurantColors from './RestaurantColors';
import connectContainer from './RestaurantColorsContainer';

export default connectContainer(RestaurantColors);
